import { useEffect, useState } from 'react'
import { LANGUAGE_EN } from '@edulastic/constants/const/languages'

const useTestCustomizeTTS = ({
  setTTSTextState,
  fetchTTSText,
  testData = {},
  firstTabLanguage = LANGUAGE_EN,
}) => {
  const [showTTSTextModal, setShowTTSTextModal] = useState(false)
  const [modalDraggable, setModalDraggable] = useState(false)
  const [voiceLanguage, setVoiceLanguage] = useState(0)
  const [selectedLanguage, setSelectedLanguage] = useState(firstTabLanguage)

  useEffect(() => {
    if (setTTSTextState) {
      setTTSTextState({
        apiStatus: false,
        result: [],
        TTSUpdateData: {
          apiStatus: false,
        },
      })
    }
  }, [setTTSTextState])

  const requestToGetTTSText = (update = false) => {
    const { _id: testId } = testData

    const requestData = {
      testId,
      updateTTSText: update,
      language: selectedLanguage,
    }

    fetchTTSText(requestData)
  }

  useEffect(() => {
    if (showTTSTextModal) {
      requestToGetTTSText()
    }
    if (!showTTSTextModal) {
      setSelectedLanguage(firstTabLanguage)
    }
  }, [showTTSTextModal, selectedLanguage, firstTabLanguage])

  return {
    showTTSTextModal,
    setShowTTSTextModal,
    modalDraggable,
    setModalDraggable,
    voiceLanguage,
    setVoiceLanguage,
    setSelectedLanguage,
    selectedLanguage,
    requestToGetTTSText,
  }
}

export default useTestCustomizeTTS
